import React from 'react';
import {IconButton, ListItem, ListItemAvatar, ListItemText, MenuItem, Select, Stack, Tooltip, Typography} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import UserAvatar from '../../../../components/UserAvatar';

export default function AccessListItem({
                                           uid,
                                           user,
                                           role,
                                           isOwner,
                                           isCurrentUser,
                                           onChangeRole,
                                           onRemoveAccess,
                                       }) {
    const roleLower = (role || '').toLowerCase();

    return (
        <ListItem sx={{px: 0.5}}>
            <ListItemAvatar>
                <UserAvatar user={user} userId={uid}/>
            </ListItemAvatar>
            <ListItemText
                primary={(user?.displayName || [user?.firstName, user?.lastName].filter(Boolean).join(' ').trim()) || user?.email || uid}
                secondary={user?.email || user?.username || uid}
            />
            <Stack direction="row" spacing={0.5} alignItems="center">
                {!isOwner && !isCurrentUser ? (
                    <>
                        <Select
                            size="small"
                            variant="standard"
                            value={roleLower === 'editor' ? 'editor' : 'viewer'}
                            onChange={(e) => onChangeRole(uid, e.target.value)}
                        >
                            <MenuItem value="viewer">Viewer</MenuItem>
                            <MenuItem value="editor">Editor</MenuItem>
                        </Select>
                        <Tooltip title="Remove access">
                            <IconButton size="small" onClick={() => onRemoveAccess(uid)}>
                                <CloseIcon fontSize="small"/>
                            </IconButton>
                        </Tooltip>
                    </>
                ) : (
                    isOwner && <Typography variant="body1" color="text.secondary">Owner</Typography>
                )}
            </Stack>
        </ListItem>
    );
}

